import { render } from "./NewsFeed.vue?vue&type=template&id=703dbb34&scoped=true"
import script from "./NewsFeed.vue?vue&type=script&lang=js"
export * from "./NewsFeed.vue?vue&type=script&lang=js"

import "./NewsFeed.vue?vue&type=style&index=0&id=703dbb34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703dbb34"]])

export default __exports__